import create from "zustand";

export interface PurchaseDrawerStore {
    purchaseId: ID | null;
    purchaseItemId: ID | null;
    contactId: ID | null;
    actions: {
        setPurchaseId: (purchaseId: ID | null) => void;
        setPurchaseItemId: (purchaseItemId: ID | null) => void;
        setContactId: (contact: ID | null) => void;
    };
}

export const usePurchaseDrawerStore = create<PurchaseDrawerStore>((set) => ({
    purchaseId: null,
    purchaseItemId: null,
    contactId: null,
    actions: {
        setPurchaseId: (purchaseId: ID | null) => set(() => ({ purchaseId })),
        setPurchaseItemId: (purchaseItemId: ID | null) => set(() => ({ purchaseItemId })),
        setContactId: (contactId: ID | null) => set(() => ({ contactId })),
    },
}));
